module.exports = __webpack_public_path__ + "img/BicimadLogo.913e99c5.png";